import React from 'react';
import PropTypes from 'prop-types';
import LocalizedLink from 'helpers/LocalizeLink';
import Picture from 'components/elements/Picture';
import { useSelector } from 'react-redux';

function LearnPracticeTradeWidget(props) {
    const auth = useSelector(store => store.auth);

    if (!props?.title && !props?.img && !props?.img_mob && !props?.descriptions && !props?.additional_text && !props?.button_text && !props?.path && !props?.items) return null;

    return (
        <div data-test-id="lpt-wr" className={"widget widget-learnpracticetradewidget" + (props?.dark ? " bg-dark" : "")}>
            <div className='container-xl row text-center mx-auto p-0'>
                <div className="col-12">
                    {props?.title ? <h2 data-test-id="lpt-title" className="text-color-changeable mb-20">{props.title}</h2> : null}
                    {
                        props?.img?.source || props?.img_mob?.source ?
                            <Picture dti="lpt-img" img={props.img} img_mob={props.img_mob} className='pic-img w-100 mb-20 mx-auto' />
                            :
                            null
                    }
                    {props?.descriptions ? <p data-test-id="lpt-description" className={(props?.dark ? 'text-white ' : '') + "text-sm-medium text-semibold mb-20"}>{props.descriptions}</p> : null}
                    {props?.additional_text ? <p data-test-id="lpt-add-text" className="text-color-changeable text-semibold text-sm-medium text-italic mb-20">{props.additional_text}</p> : null}
                    {
                        (props?.path && props?.button_text) ? 
                            auth && (props.path === '/auth' || props.path === 'auth') ?
                                <LocalizedLink dti="lpt-btn" to={'/price'} className={"btn h-42 px-12" + (props?.dark ? ' btn-dark' : '')}>
                                    {props.button_text}
                                </LocalizedLink>
                                :
                                <LocalizedLink dti="lpt-btn" to={props.path} className={"btn h-42 px-12" + (props?.dark ? ' btn-dark' : '')}>
                                    {props.button_text}
                                </LocalizedLink>
                            : null
                    }
                </div>
                {
                    props?.items ?
                        <div className="col-12 mt-4">
                            <div className="row">
                                {
                                    props.items.map((item, index) => {
                                        return (
                                            <div key={'lpt_' + index} className="opt-item col-12 col-md-4 mt-3 mb-4 mb-md-0">
                                                {
                                                    item?.img && item?.img.source ?
                                                        <div
                                                            data-test-id={"lpt-el-img-" + index}
                                                            title={item.img && item.img.title ? item.img.title : null}
                                                            style={{ backgroundImage: `url(${item.img.source})` }}
                                                            className="img img-h-75">
                                                        </div> : null
                                                }
                                                {item?.title ? <h3 data-test-id={"lpt-el-title-" + index} className={(props?.dark ? 'text-white ' : '') + 'mt-20 mb-12'}>{item.title}</h3> : null}
                                                {item?.descriptions ? <p data-test-id={"lpt-el-text-" + index} className={(props?.dark ? 'text-white ' : '') + "text-small text-justify text-sm-center mb-12"}>{item.descriptions}</p> : null}
                                                {item?.additional_text ? <p data-test-id={"lpt-el-add-text-" + index} className="text-color-changeable text-medium text-sm-small text-semibold text-italic mb-12">{item.additional_text}</p> : null}
                                                {(item?.path && item?.button_text) ?
                                                    auth && (props.path === '/auth' || props.path === 'auth') ?
                                                        <LocalizedLink dti={"lpt-el-btn-" + index} to={'/price'} className={"btn h-32 px-12" + (props?.dark ? ' btn-dark' : '')}>
                                                            {item.button_text}
                                                        </LocalizedLink> 
                                                        :
                                                        <LocalizedLink dti={"lpt-el-btn-" + index} to={item.path} className={"btn h-32 px-12" + (props?.dark ? ' btn-dark' : '')}>
                                                            {item.button_text}
                                                        </LocalizedLink> 
                                                    : null}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div> : null
                }
            </div>
        </div>
    )
}

LearnPracticeTradeWidget.propTypes = {
    title: PropTypes.string,
    descriptions: PropTypes.string,
    additional_text: PropTypes.string,
    button_text: PropTypes.string,
    link: PropTypes.string,
    path: PropTypes.string,
    img: PropTypes.object,
    position: PropTypes.number,
    widget: PropTypes.string,
    className: PropTypes.string,
    items: PropTypes.array,
};

export default LearnPracticeTradeWidget;
